import { memo } from "react";
import Screen, { type ScreenProps } from "ui/layouts/Screen";
import { WhatsAppMessagingLayout } from "ui/organizms/Setup";

const WhatsAppMessaging = (props: ScreenProps) => (
    <Screen
        {...props}
        title='Setup | WhatsApp Messaging'
    >
        <WhatsAppMessagingLayout />
    </Screen>
);

export default memo(WhatsAppMessaging);
